<template>
  <wgu-module-card
    v-bind="$attrs"
    :moduleName="moduleName"
    :style="{ left: tblLeft, width: tblWidth, top: '23vh' }"
    class="vue-table-win"
    :icon="icon"
  >
  <vue-table class="table-container pa-0"
    >
    </vue-table>
  </wgu-module-card>
</template>

<script>
import ModuleCard from '../../../src/components/modulecore/ModuleCard';
import { Mapable } from '../../../src/mixins/Mapable';
import { ColorTheme } from '../../../src/mixins/ColorTheme';
import VueTable from './VueTable';
import { WguEventBus } from '@/WguEventBus';

export default {
  name: 'vue-table-win',
  inheritAttrs: false,
  props: {
    icon: { type: String, required: false, default: 'table_chart' }
  },
  data () {
    return {
      moduleName: 'vue-table',
      layers: [],
      selLayer: null,
      tblLeft: '20%',
      tblWidth: 'calc(100vw - 20%) !important'
    }
  },
  mixins: [Mapable, ColorTheme],
  components: {
    'wgu-module-card': ModuleCard,
    'vue-table': VueTable
  },
  created () {
    WguEventBus.$on('sidebar-open', (opened) => {
      if (opened) {
        this.tblLeft = '20% !important'
        this.tblWidth = 'calc(100vw - 20%) !important'
      } else {
        this.tblLeft = '0px !important'
        this.tblWidth = '100% !important'
      }
    })
  },
  methods: {
    /**
     * This function is executed, after the map is bound (see mixins/Mapable).
     * Bind to the layers from the OpenLayers map.
     */
    onMapBound () {
      this.layers = this.map.getLayers().getArray();
    },
    close () {
      alert('close')
      setTimeout(function () {
        WguEventBus.$emit('city-value', '');
      }, 100);
    }
  }
};
</script>

<style scoped>

  /* TODO
    Generalize the positioning concept for windows,
    this interferes with positioning and draggable settings in the app.conf */

  .vue-table-win.wgu-floating {
    bottom: 70px;
    position: absolute;
    top: 23vh;
    height: 50vh; /* Exactly 50% of the viewport height */
    overflow: auto; /* Enable scrolling if content overflows */
  }
</style>
